// util/API.js
import axios from 'axios';

let onUnauthorized = null;
let isHandlingUnauthorized = false;
let onServerUnavailable = null;
let isHandlingServerUnavailable = false;

export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

export const setServerUnavailableHandler = (handler) => {
  onServerUnavailable = handler;
};

const API = axios.create({
  // baseURL: 'http://localhost:5000/api',
  baseURL: 'https://songzug.onrender.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

API.interceptors.request.use((config) => {
  // Prefer adminToken if available
  const adminToken = localStorage.getItem('adminToken');
  const userToken = localStorage.getItem('userToken');
  const token = adminToken || userToken;
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const hasNoResponse = !error?.response && !!error?.request;

    if (hasNoResponse) {
      if (!isHandlingServerUnavailable) {
        isHandlingServerUnavailable = true;
        try {
          if (onServerUnavailable) {
            onServerUnavailable();
          }
        } finally {
          setTimeout(() => { isHandlingServerUnavailable = false; }, 3000);
        }
      }
      return Promise.reject(error);
    }

    if (status === 401 || status === 419) {
      if (!isHandlingUnauthorized) {
        isHandlingUnauthorized = true;
        try {
          // Clear any stored tokens/credentials
          localStorage.removeItem('adminToken');
          localStorage.removeItem('userToken');
          sessionStorage.clear();
          // Trigger app-level handler or fallback redirect
          if (onUnauthorized) {
            onUnauthorized();
          } else if (typeof window !== 'undefined') {
            // Adjust path to your admin login route if different
            window.location.href = '/login';
          }
        } finally {
          // Debounce multiple rapid 401s
          setTimeout(() => { isHandlingUnauthorized = false; }, 1000);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;
